import { gettext } from '@eventbrite/i18n';
import {
    GET_IN_TOUCH_TEXT,
    PACKAGE_ONE,
    PACKAGE_THREE,
    PACKAGE_TWO,
} from '../../constants/main';
import { STYLE_ANCHOR } from '@eventbrite/eds-button';

export default {
    [PACKAGE_ONE]: {
        CTAs: [
            gettext('Your Current Package'),
            gettext('Upgrade'),
            GET_IN_TOUCH_TEXT,
        ],
        CTAStyles: [null, STYLE_ANCHOR, STYLE_ANCHOR],
    },
    [PACKAGE_TWO]: {
        CTAs: [
            gettext('Downgrade'),
            gettext('Your Current Package'),
            GET_IN_TOUCH_TEXT,
        ],
        CTAStyles: [STYLE_ANCHOR, null, STYLE_ANCHOR],
    },
    [PACKAGE_THREE]: {
        CTAs: [
            gettext('Downgrade'),
            gettext('Downgrade'),
            gettext('Your Current Package'),
        ],
        CTAStyles: [STYLE_ANCHOR, STYLE_ANCHOR, null],
    },
};
